let autocomplete, mapita, realMarker;
let mapaInicializado = false; // Variable para controlar si el mapa ya fue inicializado

function initMap() {
  console.log('Iniciando initMap...');
  
  const mapaContainer = document.getElementById("mapitaCool");
  const urlchida = document.getElementById("url_chida");

  if (!mapaContainer || !urlchida) {
    console.error("Error: Elementos del mapa no encontrados.");
    return;
  }

  // Si el mapa ya está inicializado, no hacer nada
  if (mapaInicializado && mapita) {
    console.log('El mapa ya está inicializado');
    return;
  }

  // Limpiar cualquier contenido previo del contenedor
  mapaContainer.innerHTML = '';

  // Inicializar autocomplete si existe el elemento
  const autocompleteElement = document.getElementById("autocomplete");
  if (autocompleteElement) {
    autocomplete = new google.maps.places.Autocomplete(autocompleteElement, {
      types: ["geocode"]
    });
    autocomplete.setFields(["address_component", "formatted_address", "place_id", "url", "geometry"]);
  }

  // Crear el mapa
  mapita = new google.maps.Map(mapaContainer, {
    center: { lat: -17.7832262, lng: -63.182158 },
    zoom: 15,
    gestureHandling: "greedy",
    fullscreenControl: false,
    streetViewControl: false,
    mapTypeControl: false,
    disableDefaultUI: true,
    rotateControl: false,
    keyboardShortcuts: false,
     fullscreenControl: false
  });

  // Al final de tu función donde inicializas 'mapita'
setTimeout(function() {
    mapita.setOptions({
        fullscreenControl: false,
        disableDefaultUI: true
    });
    console.log("Forzando ocultación de controles...");
}, 2000); // Espera 1 segundo después de cargar


  // Ajustar altura según el dispositivo
  if (window.innerWidth <= 600) {
    mapaContainer.style.height = "450px";
  } else {
    mapaContainer.style.height = "400px";
  }

  // Crear el marcador falso (fijo en el centro)
  const fakeMarker = document.createElement('div');
  fakeMarker.innerHTML = `
    <svg height="80px" width="70px" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
      <g id="_x31_57_x2C__Twitter_x2C__Location_x2C__Map">
        <g>
          <path d="M256.08,54.999c84.87,0,153.81,68.94,153.81,153.96c0,77.059-87.02,195.03-153.2,246.04 c-85.33-69.24-154.58-167.75-154.58-246.04C102.11,123.938,171.05,54.999,256.08,54.999z M330.87,205.798 c0-41.34-33.521-74.86-74.87-74.86c-41.35,0-74.86,33.52-74.86,74.86c0,41.35,33.51,74.87,74.86,74.87 C297.35,280.668,330.87,247.148,330.87,205.798z" style="fill:#FF7979;"/>
        </g>
      </g>
      <g id="Layer_1"/>
    </svg>
  `;
  fakeMarker.style.position = 'absolute';
  fakeMarker.style.top = '50%';
  fakeMarker.style.left = '50%';
  fakeMarker.style.transform = 'translate(-50%, -70%)';
  fakeMarker.style.zIndex = '1';
  fakeMarker.style.pointerEvents = 'none'; // Importante: permite clics a través del marcador
  mapaContainer.appendChild(fakeMarker);

  // Esperar a que el mapa se cargue completamente antes de agregar listeners
  google.maps.event.addListenerOnce(mapita, 'idle', function() {
    console.log('Mapa cargado completamente');
    
    // Agregar el listener para el arrastre del mapa
    google.maps.event.addListener(mapita, "dragend", function () {
      console.log('Mapa arrastrado');
      placeRealMarker();
    });

    // Agregar listener para clics en el mapa
    google.maps.event.addListener(mapita, "click", function (event) {
      console.log('Mapa clickeado');
      const clickedLocation = event.latLng;
      mapita.setCenter(clickedLocation);
      placeRealMarker();
    });

    // Colocar el marcador inicial
    placeRealMarker();
    
    mapaInicializado = true;
  });

  function placeRealMarker() {
    const center = mapita.getCenter();
    const lat = center.lat();
    const lng = center.lng();

    console.log('Colocando marcador en:', lat, lng);

    // Limpiar marcador anterior
    if (realMarker) {
      realMarker.setMap(null);
    }

    // Crear nuevo marcador invisible (solo para almacenar la posición)
    realMarker = new google.maps.Marker({
      position: { lat: lat, lng: lng },
      map: mapita,
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        scale: 0
      }
    });

    // Generar coordenadas para la URL
    const latitud = lat >= 0 ? convertirCoordenadas(lat) + 'N' : convertirCoordenadas(lat) + 'S';
    const longitud = lng >= 0 ? convertirCoordenadas(lng) + 'E' : convertirCoordenadas(lng) + 'W';

    urlchida.value = `https://www.google.com/maps/place/${latitud}, ${longitud}`;

    // Disparar evento de cambio
    var event = new Event('input', {
      bubbles: true,
      cancelable: true,
    });
    urlchida.dispatchEvent(event);

    // Calcular distancia y precio
    calcularDistancia(lat, lng);
  }

  function convertirCoordenadas(grados) {
    const absoluto = Math.abs(grados);
    const gradosEnteros = Math.floor(absoluto);
    const minutos = (absoluto - gradosEnteros) * 60;
    const minutosEnteros = Math.floor(minutos);
    const segundos = (minutos - minutosEnteros) * 60;
    return `${gradosEnteros}°${minutosEnteros}'${segundos.toFixed(1)}"`;
  }
}

// Función para reinicializar el mapa si es necesario
function reinicializarMapa() {
  mapaInicializado = false;
  if (mapita) {
    google.maps.event.clearInstanceListeners(mapita);
  }
  mapita = null;
  realMarker = null;
  initMap();
}

function calcularDistancia(latUsuario, lngUsuario) {
  const ubicacionUsuario = new google.maps.LatLng(latUsuario, lngUsuario);
  const puntoFijo = new google.maps.LatLng(-17.749599, -63.169074);

  const distancia = google.maps.geometry.spherical.computeDistanceBetween(ubicacionUsuario, puntoFijo);
  let distanciaKm = distancia / 1000;

  const kilometrosExtra = Math.floor(distanciaKm / 0.3125) * 0.125;
  distanciaKm += kilometrosExtra;
  distanciaKm = distanciaKm.toFixed(2);

  document.getElementById("distancia").textContent = "Distancia del envío: " + distanciaKm + " km";
  calcularPrecio(distanciaKm);
}

function geolocate() {
  const defaultLocation = { lat: -17.749642, lng: -63.169050 };
  const geolocationOptions = { enableHighAccuracy: true, timeout: 5000, maximumAge: 0 };

  function setAutocompleteBounds(geolocation) {
    const circle = new google.maps.Circle({
      center: geolocation,
      radius: geolocation.coords ? geolocation.coords.accuracy : 10,
    });
    if (autocomplete) {
      autocomplete.setBounds(circle.getBounds());
    }
  }

  navigator.geolocation.getCurrentPosition(
    position => setAutocompleteBounds(position),
    error => setAutocompleteBounds(defaultLocation),
    geolocationOptions
  );
}

function calcularPrecio(distanciaKm) {
  let precio = 0;

  // Condición para asignar valores a `precio` basado en la distancia   QUITAR COMENTARIO PARA VOLVER AL DELIVERY NORMAL: (/ *)
  if (distanciaKm > 0 && distanciaKm <= 1) {
      precio = 10;
  } else if (distanciaKm <= 2.7) {
     precio = 12; 
  } else if (distanciaKm <= 3) {
      precio = 12.5;
  } else if (distanciaKm <= 3.7) {
      precio = 13.5;  
  } else if (distanciaKm <= 4) {
      precio = 14.5;
  } else if (distanciaKm <= 4.7) {
      precio = 15.5;
  } else if (distanciaKm <= 5) {
      precio = 16.5;
  } else if (distanciaKm <= 5.7) {
      precio = 17.5;
  } else if (distanciaKm <= 6) {
      precio = 18.5;
  } else if (distanciaKm <= 6.7) {
      precio = 20;
  } else if (distanciaKm <= 7) {
      precio = 21.5;
  } else if (distanciaKm <= 7.7) {
      precio = 22.5;
  } else if (distanciaKm <= 8) {
      precio = 24.5;
  } else if (distanciaKm <= 8.7) {
      precio = 25.5;
  } else if (distanciaKm <= 9) {
      precio = 27.5;
  } else if (distanciaKm <= 9.7) {
      precio = 28.5;
  } else if (distanciaKm <= 10) {
      precio = 30.5;
  } else if (distanciaKm <= 10.7) {
      precio = 31;
  } else if (distanciaKm <= 11) {
      precio = 32.5;
  } else if (distanciaKm <= 12) {
      precio = 34.5;
  } else if (distanciaKm <= 13) {
      precio = 36.5;
  } else if (distanciaKm <= 14) {
      precio = 38.5;
  } else if (distanciaKm <= 15) {
      precio = 40.5;
  } else if (distanciaKm <= 16) {
      precio = 43.5;
  } else if (distanciaKm <= 17) {
      precio = 46.5;
  } else if (distanciaKm <= 18) {
      precio = 49.5;
  } else if (distanciaKm <= 19) {
      precio = 52.5;
  } else if (distanciaKm <= 20) {
      precio = 55.5;
  } else if (distanciaKm <= 21) {
      precio = 58.5;
  }

  const precioElement = document.getElementById("precio");
  const precioNuevoElement = document.getElementById("precioNuevoId");
  const mensajeEnvio = document.getElementById("mensajeenvio");
  const cotizarElement = document.getElementById("cotizarId");

  if (precio === 0) {
    if (precioElement) precioElement.style.display = "none";
    if (precioNuevoElement) precioNuevoElement.style.display = "none";
    if (cotizarElement) {
      cotizarElement.style.display = "block";
      cotizarElement.textContent = "Envio a cotizar";
    }
    if (mensajeEnvio) mensajeEnvio.textContent = "Envio gratuito"; //"Cotizaremos el envío al completar el pedido";
  } else {
    if (precioElement) {
      precioElement.style.display = "inline";
      precioElement.textContent = "Bs " + precio.toFixed(2);
    }
    if (precioNuevoElement) {
      precioNuevoElement.style.display = "block";
      precioNuevoElement.textContent = "+ Bs " + precio.toFixed(2) + " de envío";
    }
    if (cotizarElement) cotizarElement.style.display = "none";
    if (mensajeEnvio) mensajeEnvio.textContent = "";
  }

  // Almacenar el precio en localStorage
  localStorage.setItem("precioEnvio", precio.toFixed(2));

  copiarPrecioEasyCell();
  actualizarTotalCarritoConEnvio();

}

function copiarPrecioEasyCell() {
  var precioElement = document.getElementById('precio');
  var inputEasyCell = document.getElementById('es-text35');

  if (precioElement && inputEasyCell) {
    var precioValue = precioElement.textContent.trim();
    inputEasyCell.value = precioValue;

    var event = new Event('input', {
      bubbles: true,
      cancelable: true
    });
    inputEasyCell.dispatchEvent(event);
  }
}


function actualizarTotalCarritoConEnvio() {
  const envioSpan = document.getElementById("precio");

  if (!envioSpan) return;

  const envioTexto = envioSpan.textContent || "";
  const envio = parseFloat(envioTexto.replace(",", ".").replace(/[^\d.]/g, ""));

  if (isNaN(envio)) return;

  // Lista de IDs de span a actualizar
  const ids = [
    "Total_producto_y_Delivery"
  ];

  ids.forEach(function(id) {
    const totalSpan = document.getElementById(id);
    if (totalSpan) {
      const totalCarrito = parseFloat(totalSpan.dataset.total.replace(",", "."));
      if (!isNaN(totalCarrito)) {
        const totalFinal = totalCarrito + envio;
        totalSpan.innerHTML = "Bs&nbsp;&nbsp;" + totalFinal.toLocaleString("es-BO", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2
        });
      }
    }
  });
}
